import React from 'react';
import { IntercomAPI } from 'react-intercom';
import styles from './styles.scss';

function ProductCustom() {
  return (
    <div className="container-fluid main-container">
      <div className="row">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <div className="row">
            <div className="col-sm-12">
              <div className={styles.container}>
                <div className="h1 mt0">
                  Need a custom design?
                </div>
                <div className={`${styles.details} light alt-text`}>
                  Chat with a project manager and they'll give you a free quote.
                </div>
                <a className="btn btn-dc-primary btn-xs-block" onClick={() => IntercomAPI('show')}>
                  CHAT WITH US
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductCustom;



// WEBPACK FOOTER //
// ./src/components/ProductCustom/index.js